import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { SessionStorageService } from '../shared-services/services/session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class PropertySearchWidgetGuard {
    constructor(
        private authService: AuthService,
        private router: Router,
        private sessionStorageService: SessionStorageService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        const fathomUrl = route.queryParams['fathom-url'];
        if (fathomUrl || this.sessionStorageService.getItem('fathom-url')) {
            return true;
        }

        const urlParam = route.queryParams['url'];

        if (this.authService.isAuthenticated()) {
            const queryParams: Record<string, string> = { tab: '1' };
            if (urlParam) {
                queryParams['url'] = urlParam;
            }
            this.router.navigate(['properties'], { queryParams });
            return false;
        }

        this.router.navigate(['login']);
        return false;
    }
}
